<template>
  <div></div>
</template>
<script>
import { mapActions } from 'vuex';
import api from '@/api';

export default {
  async created() {
    const { code } = this.$route.query;
    if (typeof code === 'string') {
      const { access_token, id_token } = await api.token.getToken(code);
      this.setToken({ access_token, id_token });
      await this.$router.push({ name: 'dashboard' });
    }
  },
  methods: {
    ...mapActions({
      setToken: 'token/setToken',
    }),
  },
};
</script>
